/* eslint-disable max-len */
import React from 'react';
import { IndexRoute, IndexRedirect, Route, Redirect } from 'react-router';
import AllClients from 'pages/dashboard/clients/all/AllClients';
import DuplicateClients from 'src/pages/people/duplicates/DuplicateClients';
import AllScreenings from 'pages/dashboard/screenings/all/_screening_id/AllScreenings';
import AllNetworkCases from 'src/pages/dashboard/cases/all-network/AllNetworkCases';
import AllOONCases from 'pages/dashboard/cases/out-of-network/_id/contact/_contact_id/AllOONCases';
import AllExternalCases from 'pages/dashboard/cases/external/_id/contact/_contact_id/AllExternalCases';
import ARReferralsAddSupportingDetails from 'pages/assistance-requests/_assistance_request_id/referrals/new/add-supporting-details/ARReferralsAddSupportingDetails';
import ARContactsNewReview from 'pages/assistance-requests/_assistance_request_id/contacts/new/review/ARContactsNewReview';
import ARContactCasesAddAssessments from 'pages/assistance-requests/_assistance_request_id/contacts/_id/cases/new/add-case-assessments/ARContactCasesAddAssessments';
import ARContactNewCaseReview from 'pages/assistance-requests/_assistance_request_id/contacts/_id/cases/new/review/ARContactNewCaseReview';
import ARContactCasesNewDetails from 'pages/assistance-requests/_assistance_request_id/contacts/_id/cases/new/add-case-details/ARContactCasesNewDetails';
import ARContactCasesNewView from 'pages/assistance-requests/_assistance_request_id/contacts/_id/cases/new/ARContactCasesNewView';
import ARReferralsContactReview from 'pages/assistance-requests/_assistance_request_id/referrals/new/review/ARReferralsContactReview';
import ARReferralFinalReview from 'pages/assistance-requests/_assistance_request_id/referrals/new/final-review/ARReferralFinalReview';
import ARReferralServicesForm from 'pages/assistance-requests/_assistance_request_id/referrals/new/add-service-types/ARReferralServicesForm';
import AssistanceRequestsClosed from 'pages/dashboard/assistance-requests/closed/_id/Closed';
import AssistanceRequestsProcessed from 'pages/dashboard/assistance-requests/processed/_id/Processed';
import ServiceAuthorizationsContainer from 'pages/service-authorizations/ServiceAuthorizationsContainer';
import ServiceAuthorizationDetails from 'pages/service-authorizations/_id/ServiceAuthorizationDetails';
import ServiceAuthorizationAssessmentDetails from 'pages/service-authorizations/_id/ServiceAuthorizationAssessmentDetails';

import CasesAllCases from 'pages/dashboard/cases/all/_id/contact/_contact_id/AllCases';
import CasesClosedCases from 'pages/dashboard/cases/closed/_id/contact/_contact_id/ClosedCases';
import CasesOONCases from 'pages/dashboard/cases/out-of-network/_id/contact/_contact_id/OONCases';
import ClosedExternalCases from 'pages/dashboard/cases/external/_id/contact/_contact_id/ClosedExternalCases';
import ClosedOONCases from 'pages/dashboard/cases/out-of-network/_id/contact/_contact_id/ClosedOONCases';
import CaseLegacyDetailRedirect from 'pages/facesheet/_id/cases/_case_id/CaseLegacyDetailRedirect';
import CasesOpenCases from 'pages/dashboard/cases/open/_id/contact/_contact_id/OpenCases';
import ClosedReferrals from 'pages/dashboard/referrals/sent/closed/_id/ClosedReferrals';
import ContactNewAddCaseAssessments from 'pages/contacts/_id/cases/new/add-case-assessments/ContactNewAddCaseAssessments';
import CasesAssessmentDetailsView from 'pages/cases/_id/assessments/_assessment_id/CasesAssessmentDetailsView';
import ContactCasesNewView from 'pages/contacts/_id/cases/new/ContactCasesNewView';
import ContactNewAddCaseDetails from 'pages/contacts/_id/cases/new/add-case-details/ContactNewAddCaseDetails';
import ContactNewCaseReview from 'pages/contacts/_id/cases/new/review/ContactNewCaseReview';
import ContactsNewReview from 'pages/contacts/new/review/ContactsNewReview';
import ContactScreeningDetailsView from 'pages/facesheet/_id/screenings/_assessment_id/submissions/new/ContactScreeningDetailsView';
import ContactAssessmentDetailsView from 'pages/contacts/_id/assessment/_id/ContactAssessmentDetailsView';
import RequestOrUploadConsent from 'pages/consent/_contactId/_itemType/RequestOrUploadConsent';
import DraftReferrals from 'pages/dashboard/referrals/sent/drafts/_id/DraftReferrals';
import EnrollmentDetailPage from 'pages/enrollments/components/DetailPage/EnrollmentDetailPage';
import EnrollmentsContainer from 'pages/enrollments/EnrollmentsContainer';
import EnrollmentAssessmentDetailsView from 'pages/enrollments/components/EnrollmentAssessmentDetailsView';
import { EulaAgreement } from '@unite-us/app-components';
import Exports from 'pages/exports/Exports';
import ExternalCases from 'pages/dashboard/cases/external/_id/contact/_contact_id/ExternalCases';
import Facesheet from 'pages/facesheet/Facesheet';
import FacesheetAssessments from 'pages/facesheet/_id/forms/FacesheetAssessments';
import EligibilityAssessmentsRoute from 'pages/facesheet/_id/eligibility/EligibilityAssessmentsRoute';
import NewEligibilityAssessment from 'pages/facesheet/_id/eligibility/NewAssessment';
import ViewEligibilityAssessment from 'pages/facesheet/_id/eligibility/ViewEligibilityAssessment';
import EligibilityAssessments from 'pages/facesheet/_id/eligibility/EligibilityAssessments';
import FacesheetScreenings from 'pages/facesheet/_id/screenings/FacesheetScreenings';
import FacesheetCases from 'pages/facesheet/_id/cases/FacesheetCases';
import FacesheetOverview from 'pages/facesheet/_id/FacesheetOverview';
import FacesheetProfile from 'pages/facesheet/_id/profile/FacesheetProfile';
import FacesheetReferrals from 'pages/facesheet/_id/referrals/FacesheetReferrals';
import FacesheetSocialCarePlan from 'pages/facesheet/_id/social-care-plan/FacesheetSocialCarePlan';
import FacesheetScreeningDetail from 'pages/facesheet/_id/forms/screenings/_screening_id/FacesheetScreeningDetail';
import GroupReports from 'pages/reports/group/GroupReports';
import Home from 'pages/Home';
import Insights from 'pages/insights/Insights';
import Tasks from 'pages/tasks/Tasks';
import TasksV3 from 'pages/tasksV3/TasksV3';
import TaskView from 'pages/tasksV3/TaskView';
import AcceptedInvoicesDWQ from 'pages/invoices/pages/AcceptedInvoicesDWQ';
import AllInvoices from 'pages/invoices/pages/AllInvoices';
import ArchivedInvoicesDWQ from 'pages/invoices/pages/ArchivedInvoicesDWQ';
import ClosedInvoices from 'pages/invoices/pages/ClosedInvoices';
import DisputedInvoices from 'pages/invoices/pages/DisputedInvoices';
import DraftInvoices from 'pages/invoices/pages/DraftInvoices';
import InvoiceDetailPage from 'pages/invoices/components/InvoiceDetailPage';
import InvoicesContainer from 'pages/invoices/InvoicesContainer';
import OpenInvoices from 'pages/invoices/pages/OpenInvoices';
import RejectedInvoicesDWQ from 'pages/invoices/pages/RejectedInvoicesDWQ';
import SubmittedInvoicesDWQ from 'pages/invoices/pages/SubmittedInvoicesDWQ';
import OAuthLogin from 'pages/callback/OAuthLogin';
import MilitaryReport from 'pages/reports/group/_id/military/MilitaryReport';
import Network from 'pages/network/Network';
import NetworkUsers from 'pages/network/_id/users/NetworkUsers';
import NetworkGroups from 'pages/network/_id/orgs/NetworkGroups';
import NewAssistanceRequests from 'pages/dashboard/new/assistance-requests/_id/NewAssistanceRequests';
import GroupsInvitationsNew from 'pages/invitations/new/GroupsInvitationsNew';
import NewReferrals from 'pages/dashboard/new/referrals/_id/NewReferrals';
import NewScreeningReviewContactDetails from 'pages/screenings/new/review/NewScreeningReviewContactDetails';
import OrganizationContainerLazyLoader from 'src/pages/organization/settings/OrganizationContainerLazyLoader';
import Organization from 'src/pages/organization/settings';
import OrganizationEdit from 'src/pages/organization/settings/Edit';
import OrganizationUsers from 'src/pages/organization/settings/users';
import OrganizationUserDetail from 'src/pages/organization/settings/users/_id';
import OrganizationLocationNew from 'src/pages/organization/settings/locations/_id/New';
import OrganizationLocationEdit from 'src/pages/organization/settings/locations/_id/Edit';
import OrganizationProgramNew from 'src/pages/organization/settings/programs/New';
import OrganizationProgramEdit from 'src/pages/organization/settings/programs/_id/Edit';
import OrganizationUserNew from 'src/pages/organization/settings/users/New';
import OrganizationUserEdit from 'src/pages/organization/settings/users/_id/Edit';
import ProviderOnboarding from 'src/pages/provider-onboarding/ProviderOnboarding';
import MergeSelect from 'pages/people/merge-select/MergeSelect';
import MergeDetails from 'pages/people/merge-details/MergeDetails';
import PopulationReport from 'pages/reports/group/_id/population/PopulationReport';

import ProviderToProviderReferrals from 'pages/dashboard/referrals/provider-to-provider/_id/ProviderToProviderReferrals';
import RecalledReferrals from 'pages/dashboard/referrals/recalled/_id/RecalledReferrals';
import ReferralsAddSupportingDetails from 'pages/referrals/new/add-supporting-details/ReferralsAddSupportingDetails';
import ReferralAssessmentDetailsView from 'pages/referrals/_id/assessments/_assessment_id/ReferralAssessmentDetailsView';
import ReferralLegacyDetailRedirect from 'pages/referrals/drafts/_id/ReferralLegacyDetailRedirect';
import ReferralMilitaryInformation from 'pages/referrals/_id/military-information/_contact_id/ReferralMilitaryInformation';
import ReferralsContactReview from 'pages/referrals/new/review/ReferralsContactReview';
import ReferralsFinalReview from 'pages/referrals/new/final-review/ReferralsFinalReview';
import ReferralNewServicesForm from 'pages/referrals/new/add-service-types/ReferralNewServicesForm';
import ReferralsInReview from 'pages/dashboard/referrals/in-review/_id/ReferralsInReview';
import ClosedInboundReferrals from 'pages/dashboard/new/closed/_id/ClosedInboundReferrals';
import RejectedReferrals from 'pages/dashboard/referrals/rejected/_id/RejectedReferrals';
import ResourceLists from 'pages/resourceLists/ResourceLists';
import { ScreeningDetailHOC } from 'pages/components';
import ScreeningAddSupportingDetails from 'pages/screenings/_screening_id/need/_need_id/referrals/new/add-supporting-details/ScreeningAddSupportingDetails';
import ScreeningContactReview from 'pages/screenings/_screening_id/need/_need_id/referrals/new/review/ScreeningContactReview';
import ScreeningNeedReferralAddContactInfo from 'pages/screenings/_screening_id/need/_need_id/referrals/new/add-contact-information/ScreeningNeedReferralAddContactInfo';
import ScreeningNewFormWrapper from 'pages/screenings/new/screening/ScreeningNewFormWrapper';
import ScreeningSearchContactStep from 'pages/screenings/_screening_id/need/_need_id/referrals/new/search/ScreeningSearchContactStep';
import Search from 'pages/search/Search';
import ScreeningToReferral from 'pages/screenings/_screening_id/need/_need_id/referrals/new/add-service-types/ScreeningToReferral';
import SendReferralCard from 'pages/referrals/_id/send/SendReferralCard';
import ScreeningConfirmationStep from 'pages/screenings/_screening_id/need/_need_id/referrals/new/confirm/ScreeningConfirmationStep';
import ScreeningFinalReview from 'pages/screenings/_screening_id/need/_need_id/referrals/new/final-review/ScreeningFinalReview';
import SentReferrals from 'pages/dashboard/referrals/sent/SentReferrals';
import ServicesReport from 'pages/reports/group/_id/services/ServicesReport';
import TokenLoginView from 'pages/impersonate/TokenLoginView';
import Uploads from 'pages/facesheet/_id/uploads/Uploads';
import VerbalConsentScript from 'pages/consent/verbal-consent-script/VerbalConsentScript';
import UserSettings from 'pages/user/settings/UserSettings';
import UserAccountInformation from 'pages/user/settings/UserAccountInformation';
import NotificationPreferencesForm from 'src/components/NotificationPreferences/NotificationPreferencesForm';
import { DASHBOARD_EVENTS } from 'common/utils/EventTracker/utils/eventConstants';
import {
  scrn7ScreeningsCompletion,
  scrn655inboundScreeningsDashboard,
} from 'common/utils/FeatureFlags/flags';
import NewItemStepper from 'common/display/NewItemStepper';
import {
  ContactSearch,
  ContactConfirmation,
  AddContactInformation,
} from 'common/display/NewItemStepper/components';
import App from 'src/components/App/components/App';
import ContactMilitaryInformation from 'src/components/MilitaryInformation/components/ContactMilitaryInformation';
import Dashboard from 'src/components/Dashboard';
import AllServiceAuthorizations from 'pages/service-authorizations/pages/AllServiceAuthorizations';
import OpenServiceAuthorizations from 'pages/service-authorizations/pages/OpenServiceAuthorizations';
import AcceptedServiceAuthorizations from 'pages/service-authorizations/pages/AcceptedServiceAuthorizations';
import RejectedServiceAuthorizations from 'pages/service-authorizations/pages/RejectedServiceAuthorizations';
import VoidedServiceAuthorizations from 'pages/service-authorizations/pages/VoidedServiceAuthorizations';
import AllEnrollments from 'pages/enrollments/pages/AllEnrollments';
import OpenEnrollments from 'pages/enrollments/pages/OpenEnrollments';
import AcceptedEnrollments from 'pages/enrollments/pages/AcceptedEnrollments';
import RejectedEnrollments from 'pages/enrollments/pages/RejectedEnrollments';
import CanceledEnrollments from 'pages/enrollments/pages/CanceledEnrollments';
import MessageCenter from 'src/pages/message-center/pages/MessageCenter';
import MyNetworkPrograms from 'src/pages/network/_id/MyNetworkPrograms';
import ExternalScreenings from 'pages/dashboard/screenings/external/ExternalScreenings';
import Referrals from './referrals/2/Referrals';
import SupersetSearch from '../components/Search/SupersetSearch';
import Screenings from './screenings/Screenings';

/**
 * uuids will be mapped to Jira project keys in datadog log ingest.
 * new uuids were generated for these keys, and they do not correlate to any Core entities.
 *  */
const UU_OWNERS = {
  resourcesExternal: '9a19bba2-2dd1-4cb1-8df4-7ea63edb8e32', // HINT
  resourcesPlatform: 'd04f62bc-6742-4d26-bca0-edd5064a382e', // CERB
  casesAndReferrals: '87607c22-6ab9-4a0b-9a45-831c18864244', // CRTB
  screenings: '5a68f017-2f0a-4528-8992-b6ef8eceb3cd', // SCRN
  e2eExp: 'b4c7d8e9-f0a1-42b3-83c4-d5e6f7a8b9c0', // HBH
  clients: 'c5d6e7f8-a9b0-41c2-93d4-e5f6a7b8c9d0', // CL
  enrollments: 'd6e7f8a9-b0c1-40d2-a3e4-f5a6b7c8d9e0', // PAYS
  authorizations: 'e7f8a9b0-c1d2-4e3f-b4c5-d6e7f8a9b0c1', // PAYS
  paymentsAll: 'f8a9b0c1-d2e3-4f4a-c5d6-e7f8a9b0c1d2', // PAYS
  tools: 'a9b0c1d2-e3f4-4a5b-d6e7-f8a9b0c1d2e3', // TOOL
  unowned: 'ae6e88d7-a54b-4ffb-bfc2-52b1ac143768', // Needs assignmentz
};

export default function configAuthenticatedRoutes({ getState }) {
  const catchAllLoggedInRedirectPath = '/';
  const oonLabel = 'OFF-PLATFORM CASES';
  return (
    <Route>
      <Route path="onboarding*" component={ProviderOnboarding} uuOwnedBy={UU_OWNERS.resourcesExternal} />
      <Route path="account" component={EulaAgreement} uuOwnedBy={UU_OWNERS.e2eExp} />
      <Route path="callback" component={OAuthLogin} uuOwnedBy={UU_OWNERS.e2eExp} />
      <Route path="impersonate" component={TokenLoginView} uuOwnedBy={UU_OWNERS.e2eExp} />
      <Route path="/" component={App} uuOwnedBy={UU_OWNERS.unowned}>
        <IndexRoute component={Home} title="Home" />
        <Route
          path="dashboard" component={Dashboard} title="Dashboard"
          uuOwnedBy={UU_OWNERS.casesAndReferrals}
        >
          <Route path="new" label="INBOUND REFERRALS">
            <Route
              path="referrals(/:id)"
              label="Needs Action"
              component={NewReferrals}
              countPath="referrals.received.pending"
              eventConstant={DASHBOARD_EVENTS.navNewReferrals}
            />
            <Route
              path="in-review(/:id)"
              label="In Review"
              component={ReferralsInReview}
              countPath="referrals.received.in_review"
              eventConstant={DASHBOARD_EVENTS.navReferralsInReview}
            />
            <Route
              path="closed(/:id)"
              label="Closed"
              component={ClosedInboundReferrals}
              eventConstant={DASHBOARD_EVENTS.navClosedInboundReferrals}
            />
          </Route>
          <Route path="assistance-requests" label="ASSISTANCE REQUESTS">
            <Route
              path="new(/:id)"
              label="Needs Action"
              component={NewAssistanceRequests}
              countPath="assistance_requests.pending"
              eventConstant={DASHBOARD_EVENTS.navNewAssistanceRequest}
            />
            <Route
              path="closed(/:id)"
              label="Closed"
              component={AssistanceRequestsClosed}
              eventConstant={DASHBOARD_EVENTS.navAssistanceRequestClosed}
            />
            <Route
              path="processed(/:id)"
              label="Processed"
              component={AssistanceRequestsProcessed}
              eventConstant={DASHBOARD_EVENTS.navAssistanceRequestProcesssed}
            />
          </Route>
          <Route path="cases" label="INTERNAL CASES">
            <Route
              path="open(/:id/contact/:contact_id)"
              label="Open"
              component={CasesOpenCases}
              eventConstant={DASHBOARD_EVENTS.navCasesOpen}
            />
            <Route
              path="closed(/:id/contact/:contact_id)"
              label="Closed"
              component={CasesClosedCases}
              eventConstant={DASHBOARD_EVENTS.navCasesClosed}
            />
            <Route
              path="all(/:id/contact/:contact_id)"
              label="All"
              component={CasesAllCases}
              eventConstant={DASHBOARD_EVENTS.navCasedAll}
            />
          </Route>
          <Route path="screenings" label="INBOUND SCREENINGS" uuOwnedBy={UU_OWNERS.screenings}>
            <Route
              path="received"
              label="Received"
              component={ExternalScreenings}
              countPath="screenings.external"
              eventConstant={DASHBOARD_EVENTS.navScreeningsExternal}
              onEnter={
                (_params, replace) => {
                  const state = getState();
                  if (!scrn7ScreeningsCompletion(state) || !scrn655inboundScreeningsDashboard(state)) {
                    replace('/');
                  }
                }
              }
            />
          </Route>
          <Route path="referrals/sent" label="OUTBOUND REFERRALS">
            <Route
              path="draft(/:id/contact/:contact_id)"
              label="Drafts"
              component={DraftReferrals}
              countPath="referrals.sent.draft"
              eventConstant={DASHBOARD_EVENTS.navReferralsDrafts}
            />
            <Route
              path="rejected(/:id)"
              label="Rejected"
              component={RejectedReferrals}
              countPath="referrals.sent.rejected"
              eventConstant={DASHBOARD_EVENTS.navReferralsRejected}
            />
            <Route
              path="recalled(/:id)"
              label="Recalled"
              component={RecalledReferrals}
              countPath="referrals.sent.recalled"
              eventConstant={DASHBOARD_EVENTS.navReferralsRecalled}
            />
            <Route
              path="needs-action(/:id)"
              label="Needs Action"
              status="pending"
              component={SentReferrals}
              eventConstant={DASHBOARD_EVENTS.navReferralsSentNeedsAction}
            />
            <Route
              path="in-review(/:id)"
              label="In Review"
              status="in_review"
              component={SentReferrals}
              eventConstant={DASHBOARD_EVENTS.navReferralsSentInReview}
            />
            <Route
              path="closed(/:id)"
              label="Closed"
              component={ClosedReferrals}
              eventConstant={DASHBOARD_EVENTS.navReferralsClosed}
            />
            <Route
              path="all(/:id)"
              label="All"
              status="all"
              component={SentReferrals}
              eventConstant={DASHBOARD_EVENTS.navReferralsSentAll}
            />
          </Route>
          <Route path="external-cases" label="EXTERNAL CASES">
            <Route
              path="open(/:id/contact/:contact_id)"
              label="Open"
              component={ExternalCases}
              eventConstant={DASHBOARD_EVENTS.navCasesExternal}
            />
            <Route
              path="closed(/:id/contact/:contact_id)"
              label="Closed"
              component={ClosedExternalCases}
              eventConstant={DASHBOARD_EVENTS.navClosedExternalCases}
            />
            <Route
              path="all(/:id/contact/:contact_id)"
              label="All"
              component={AllExternalCases}
              eventConstant={DASHBOARD_EVENTS.navCasesAllExternal}
            />
          </Route>
          <Route path="oon-cases" label={oonLabel}>
            <Route
              path="open(/:id/contact/:contact_id)"
              label="Open"
              component={CasesOONCases}
              eventConstant={DASHBOARD_EVENTS.navCasesOON}
            />
            <Route
              path="closed(/:id/contact/:contact_id)"
              label="Closed"
              component={ClosedOONCases}
              eventConstant={DASHBOARD_EVENTS.navClosedOONCases}
            />
            <Route
              path="all(/:id/contact/:contact_id)"
              label="All"
              component={AllOONCases}
              eventConstant={DASHBOARD_EVENTS.navCasesAllOON}
            />
          </Route>
          <Route path="all-network" label="ALL NETWORK">
            <Route
              path="referrals(/:id)"
              label="Referrals"
              component={ProviderToProviderReferrals}
              eventConstant={DASHBOARD_EVENTS.navReferralsProviderToProvider}
            />
            <Route
              path="cases(/:id/contact/:contact_id)"
              label="Cases"
              component={AllNetworkCases}
              eventConstant={DASHBOARD_EVENTS.navCasedAll}
            />
          </Route>
        </Route>
        <Route path="dashboard/clients" uuOwnedBy={UU_OWNERS.clients}>
          <Route
            path="all"
            label="All"
            component={AllClients}
            eventConstant={DASHBOARD_EVENTS.navClientsAll}
          />
        </Route>
        <Route path="screenings" label="Screenings" uuOwnedBy={UU_OWNERS.screenings}>
          <Route
            path="all(/:screening_id)"
            label="All"
            component={AllScreenings}
            eventConstant={DASHBOARD_EVENTS.navScreeningsAll}
          />
        </Route>
        <Route path="people" uuOwnedBy={UU_OWNERS.clients}>
          <Route path="duplicates/:person_id" component={MergeSelect} />
          <Route path="duplicates" component={DuplicateClients} />
          <Route path="merge" component={MergeDetails} />
        </Route>
        <Route path="cases/:id" title="Cases" uuOwnedBy={UU_OWNERS.casesAndReferrals}>
          <Route path="assessments/:assessment_id/submissions/new" component={CasesAssessmentDetailsView} />
          <Route path="assessments/:assessment_id/submissions/:submission_id" component={CasesAssessmentDetailsView} />
        </Route>

        <Route path="referrals/2/*" component={Referrals} uuOwnedBy={UU_OWNERS.casesAndReferrals} />
        <Route path="referrals" title="Referrals" uuOwnedBy={UU_OWNERS.casesAndReferrals}>
          <Route path="(drafts/):id" component={ReferralLegacyDetailRedirect} />
          <IndexRedirect to="/dashboard/new/referrals" />
          <Route path=":id/military-information/:contact_id" component={ReferralMilitaryInformation} />
          <Route path=":id/assessments/:assessment_id/submissions/new" component={ReferralAssessmentDetailsView} />
          <Route path=":id/assessments/:assessment_id/submissions/:submission_id" component={ReferralAssessmentDetailsView} />
          <Route path=":id/send" component={SendReferralCard} />
          <Route path="new" component={NewItemStepper} title="Create Referral">
            <Route path="search" component={ContactSearch} />
            <Route path="confirm" component={ContactConfirmation} />
            <Route path="add-contact-information" from="referral" component={AddContactInformation} />
            <Route path="review" component={ReferralsContactReview} />
            <Route path="add-service-types" component={ReferralNewServicesForm} />
            <Route path="add-supporting-details" component={ReferralsAddSupportingDetails} />
            <Route path="final-review" component={ReferralsFinalReview} />
          </Route>
          <Route path="create">
            <Route
              path="add-resources" title="Add Resources" component={SupersetSearch}
              uuOwnedBy={UU_OWNERS.resourcesPlatform}
            />
          </Route>
        </Route>

        <Route path="consent/verbal-consent-script" component={VerbalConsentScript} uuOwnedBy={UU_OWNERS.clients} />
        <Route path="consent/:personId/:itemType" component={RequestOrUploadConsent} uuOwnedBy={UU_OWNERS.clients} />

        <Route path="assistance-requests/:assistance_request_id" uuOwnedBy={UU_OWNERS.casesAndReferrals}>
          <IndexRedirect to="/dashboard/new/assistance-requests/:assistance_request_id" />
          <Route path="assessments/:assessment_id/submissions/new" component={CasesAssessmentDetailsView} />
          <Route path="assessments/:assessment_id/submissions/:submission_id" component={CasesAssessmentDetailsView} />
          <Route
            path="contacts/new"
            component={NewItemStepper}
            title="Create Client"
          >
            <Route path="add-contact-information" from="case-ar" component={AddContactInformation} />
            <Route path="confirm" component={ContactConfirmation} />
            <Route path="review" component={ARContactsNewReview} />
            <Route path="search" component={ContactSearch} />
          </Route>
          <Route path="contacts/:id/cases">
            <Route path="new" component={ARContactCasesNewView} title="Create Case">
              <Route path="add-case-details" component={ARContactCasesNewDetails} />
              <Route path="add-case-assessments" component={ARContactCasesAddAssessments} />
              <Route path="review" component={ARContactNewCaseReview} />
            </Route>
          </Route>
          <Route path="referrals/new" component={NewItemStepper} title="Create Referral">
            <Route path="add-contact-information" from="referral-ar" component={AddContactInformation} />
            <Route path="add-service-types" component={ARReferralServicesForm} />
            <Route path="add-supporting-details" component={ARReferralsAddSupportingDetails} />
            <Route path="confirm" component={ContactConfirmation} />
            <Route path="final-review" component={ARReferralFinalReview} />
            <Route path="review" component={ARReferralsContactReview} />
            <Route path="search" component={ContactSearch} />
          </Route>
        </Route>

        <Route path="invitations/new" component={GroupsInvitationsNew} />

        <Route
          path="contacts/new"
          component={NewItemStepper}
          title="Create Client"
          uuOwnedBy={UU_OWNERS.clients}
        >
          <Route path="add-contact-information" from="nav" component={AddContactInformation} />
          <Route path="confirm" component={ContactConfirmation} />
          <Route path="review" component={ContactsNewReview} />
          <Route path="search" component={ContactSearch} />
        </Route>

        <Route path="contacts/:id" uuOwnedBy={UU_OWNERS.clients}>
          <IndexRedirect to="/facesheet/:id" />
          <Route path="cases" uuOwnedBy={UU_OWNERS.casesAndReferrals}>
            <Route path="new" component={ContactCasesNewView} title="Create Case">
              <Route path="add-case-details" component={ContactNewAddCaseDetails} />
              <Route path="add-case-assessments" component={ContactNewAddCaseAssessments} />
              <Route path="review" component={ContactNewCaseReview} />
            </Route>
          </Route>
          <Route path="assessments/:assessment_id" component={ContactAssessmentDetailsView} uuOwnedBy={UU_OWNERS.clients} />
        </Route>

        <Route
          path="facesheet"
          component={Facesheet}
          title="Face Sheet"
          uuOwnedBy={UU_OWNERS.clients}
        >
          <Route path=":id" component={FacesheetOverview} />
          <Route path=":id/cases" component={FacesheetCases} uuOwnedBy={UU_OWNERS.casesAndReferrals} />
          <Route path=":id/cases/:case_id" component={CaseLegacyDetailRedirect} uuOwnedBy={UU_OWNERS.casesAndReferrals} />
          <Route path=":id/screenings" component={FacesheetScreenings} uuOwnedBy={UU_OWNERS.screenings}>
            <Route path=":assessment_id/submissions/new" component={ContactScreeningDetailsView} />
          </Route>
          <Route path=":id/eligibility" component={EligibilityAssessmentsRoute} uuOwnedBy={UU_OWNERS.casesAndReferrals}>
            <IndexRoute component={EligibilityAssessments} />
            <Route path="all" component={EligibilityAssessments} />
            <Route path="view/:assessment_id" component={ViewEligibilityAssessment} />
            <Route path="new(/:assessment_id)(/:step)" component={NewEligibilityAssessment} />
            <Route mode="edit" path="edit/:assessment_id(/:step)" component={NewEligibilityAssessment} />
          </Route>
          <Route path=":id/forms" component={FacesheetAssessments} uuOwnedBy={UU_OWNERS.casesAndReferrals}>
            <Route path=":assessment_id/submissions/new" component={ContactAssessmentDetailsView} />
            <Route path=":assessment_id/submissions/:submission_id" component={ContactAssessmentDetailsView} />
            <Route path="screenings/:screening_id" component={FacesheetScreeningDetail} />
          </Route>
          <Route path=":id/profile" component={FacesheetProfile} />
          <Route path=":id/referrals" component={FacesheetReferrals} uuOwnedBy={UU_OWNERS.casesAndReferrals} />
          <Route path=":id/social-care-plan" component={FacesheetSocialCarePlan} uuOwnedBy={UU_OWNERS.clients} />
          <Route path=":id/uploads" component={Uploads} />
          <Route
            path=":id/resource-lists*"
            component={ResourceLists}
            uuOwnedBy={UU_OWNERS.resourcesPlatform}
          />
        </Route>

        <Route
          path="browse-resources"
          component={Network}
          title="Network Profile"
          uuOwnedBy={UU_OWNERS.resourcesPlatform}
        >
          <IndexRoute component={MyNetworkPrograms} />
          <Route path="browse" component={MyNetworkPrograms} />
          <Route path="orgs" component={NetworkGroups} />
          <Route path="users" component={NetworkUsers} />
        </Route>

        <Route
          path="user/settings"
          component={UserSettings}
          title="Settings"
          uuOwnedBy={UU_OWNERS.e2eExp}
        >
          <IndexRoute component={UserAccountInformation} />
          <Route path="notifications" component={NotificationPreferencesForm} />
        </Route>

        <Route path="military-information/:id" component={ContactMilitaryInformation} uuOwnedBy={UU_OWNERS.clients} />

        <Route path="workflow-dashboard" title="Workflow Dashboard">
          <IndexRedirect to="/dashboard" />
          <Redirect from="*" to="/dashboard" />
        </Route>

        <Route
          path="search"
          component={Search}
          title="Search Results"
          uuOwnedBy={UU_OWNERS.clients}
        />

        <Route
          path="screenings/v2*"
          component={Screenings}
          label="All"
          onEnter={
            (_params, replace) => {
              const state = getState();
              if (!scrn7ScreeningsCompletion(state)) {
                replace('/');
              }
            }
          }
          uuOwnedBy={UU_OWNERS.screenings}
        />

        <Route path="screenings" title="Client Screening" uuOwnedBy={UU_OWNERS.screenings}>
          <Route path="new" component={NewItemStepper} title="Create Client Screening">
            <Route path="search" component={ContactSearch} />
            <Route path="confirm" component={ContactConfirmation} />
            <Route path="review" component={NewScreeningReviewContactDetails} />
            <Route path="add-contact-information" from="screening" component={AddContactInformation} />
            <Route path="screening" component={ScreeningNewFormWrapper} />
          </Route>
          <Route path=":screening_id" component={ScreeningDetailHOC} />
          <Route path=":screening_id/need/:need_id/referrals/new" component={NewItemStepper} title="Create Referral">
            <Route path="add-contact-information" from="screenings" component={ScreeningNeedReferralAddContactInfo} />
            <Route path="add-service-types" component={ScreeningToReferral} />
            <Route path="add-supporting-details" component={ScreeningAddSupportingDetails} />
            <Route path="confirm" component={ScreeningConfirmationStep} />
            <Route path="review" component={ScreeningContactReview} />
            <Route path="search" component={ScreeningSearchContactStep} />
            <Route path="final-review" component={ScreeningFinalReview} />
          </Route>
        </Route>

        <Route path="reports/group" component={GroupReports} title="Group Report Dashboard">
          <Route path=":id/population" component={PopulationReport} />
          <Route path=":id/services" component={ServicesReport} />
          <Route path=":id/military" component={MilitaryReport} />
        </Route>

        <Route
          path="message-center" component={MessageCenter} title="Message Center"
          uuOwnedBy={UU_OWNERS.e2eExp}
        />
        <Route
          path="message-center/:conversationId" component={MessageCenter} title="Message Center"
          uuOwnedBy={UU_OWNERS.e2eExp}
        />
        <Route
          path="exports" component={Exports} title="Exports"
          uuOwnedBy={UU_OWNERS.e2eExp}
        />

        <Route path="insights" component={Insights} title="Insights" />

        <Route
          path="tasks" component={Tasks} title="Tasks"
          uuOwnedBy={UU_OWNERS.screenings}
        >
          <Route
            path="all"
            label="All Tasks"
            component={Tasks}
            eventConstant={DASHBOARD_EVENTS.navTasksAll}
          />
          <Route
            path="inbound-screenings"
            label="Inbound Screenings Tasks"
            component={Tasks}
            eventConstant={DASHBOARD_EVENTS.navTasksInboundScreening}
          />
          <Route
            path="user-created"
            label="User-Created Tasks"
            component={Tasks}
            eventConstant={DASHBOARD_EVENTS.navTasksUserCreated}
          />
        </Route>

        <Route
          path="tasksv3" component={TasksV3} title="Tasks"
          uuOwnedBy={UU_OWNERS.screenings}
        >
          <Route
            path="all"
            label="All Tasks"
            component={TasksV3}
            eventConstant={DASHBOARD_EVENTS.navTasksAll}
          />
          <Route
            path="inbound-screenings"
            label="Inbound Screening Tasks"
            component={TasksV3}
            eventConstant={DASHBOARD_EVENTS.navTasksInboundScreening}
          />
          <Route
            path="user-created"
            label="User-Created Tasks"
            component={TasksV3}
            eventConstant={DASHBOARD_EVENTS.navTasksUserCreated}
          />
          <Route
            path=":taskId"
            component={TaskView}
          />
        </Route>

        {/* eslint-disable react/jsx-max-props-per-line */}
        <Route path="invoices" component={InvoicesContainer} title="Invoices" uuOwnedBy={UU_OWNERS.paymentsAll}>
          <IndexRedirect to="/invoices/all" />
          <Route path="draft" component={DraftInvoices} title="Draft Invoices">
            <Route path=":id" component={InvoiceDetailPage} title="View Invoice Details" />
          </Route>
          <Route path="rejected" component={RejectedInvoicesDWQ} title="Rejected Invoices">
            <Route path=":id" component={InvoiceDetailPage} title="View Invoice Details" />
          </Route>
          <Route path="disputed" component={DisputedInvoices} title="Disputed Invoices">
            <Route path=":id" component={InvoiceDetailPage} title="View Invoice Details" />
          </Route>
          <Route path="submitted" component={SubmittedInvoicesDWQ} title="Submitted Invoices">
            <Route path=":id" component={InvoiceDetailPage} title="View Invoice Details" />
          </Route>
          <Route path="accepted" component={AcceptedInvoicesDWQ} title="Accepted Invoices">
            <Route path=":id" component={InvoiceDetailPage} title="View Invoice Details" />
          </Route>
          <Route path="open" component={OpenInvoices} title="Open Invoices">
            <Route path=":id" component={InvoiceDetailPage} title="View Invoice Details" />
          </Route>
          <Route path="closed" component={ClosedInvoices} title="Closed Invoices">
            <Route path=":id" component={InvoiceDetailPage} title="View Invoice Details" />
          </Route>
          <Route path="all" component={AllInvoices} title="All Invoices">
            <Route path=":id" component={InvoiceDetailPage} title="View Invoice Details" />
          </Route>
          <Route path="archive" component={ArchivedInvoicesDWQ} title="Archived Invoices">
            <Route path=":id" component={InvoiceDetailPage} title="View Invoice Details" />
          </Route>
          <Route path=":id" component={InvoiceDetailPage} title="View Invoice" />
        </Route>
        {/* eslint-enable react/jsx-max-props-per-line */}

        <Route
          path="authorizations" component={ServiceAuthorizationsContainer} title="Authorizations"
          uuOwnedBy={UU_OWNERS.authorizations}
        >
          <IndexRedirect to="/authorizations/all" />
          <Route
            path="all" component={AllServiceAuthorizations} label="All Authorizations"
            title="All Authorizations"
          />
          <Route
            path="open" component={OpenServiceAuthorizations} label="Open Authorizations"
            title="Open Authorizations"
          />
          <Route
            path="accepted" component={AcceptedServiceAuthorizations} label="Accepted Authorizations"
            title="Accepted Authorizations"
          />
          <Route
            path="voided" component={VoidedServiceAuthorizations} label="Voided Authorizations"
            title="Voided Authorizations"
          />
          <Route
            path="rejected" component={RejectedServiceAuthorizations} label="Rejected Authorizations"
            title="Rejected Authorizations"
          />
          <Route path=":id" component={ServiceAuthorizationDetails} title="Authorization Details" />
          <Route path=":id/person/:person_id/forms/:assessment_id/submissions/:submission_id" component={ServiceAuthorizationAssessmentDetails} />
        </Route>

        <Route
          path="enrollments" component={EnrollmentsContainer} title="Enrollments"
          uuOwnedBy={UU_OWNERS.enrollments}
        >
          <IndexRedirect to="/enrollments/all" />
          <Route
            path="open" component={OpenEnrollments} label="Open Enrollments"
            title="Open Enrollments"
          />
          <Route
            path="accepted" component={AcceptedEnrollments} label="Accepted Enrollments"
            title="Accepted Enrollments"
          />
          <Route
            path="rejected" component={RejectedEnrollments} label="Rejected Enrollments"
            title="Rejected Enrollments"
          />
          <Route
            path="canceled" component={CanceledEnrollments} label="Canceled Enrollments"
            title="Canceled Enrollments"
          />
          <Route
            path="all" component={AllEnrollments} label="All Enrollments"
            title="All Enrollments"
          />
          <Route path=":id" component={EnrollmentDetailPage} title="View Enrollment Request" />
          <Route path=":id/person/:person_id/forms/:assessment_id/submissions/:submission_id" component={EnrollmentAssessmentDetailsView} />
        </Route>

        <Route
          path="organization/settings"
          component={OrganizationContainerLazyLoader}
          title="Organization Settings"
          uuOwnedBy={UU_OWNERS.resourcesExternal}
        >
          <IndexRoute component={Organization} />
          <Route path="edit" component={OrganizationEdit} title="Edit Organization" />
          <Route path="locations/new" component={OrganizationLocationNew} title="Add Location" />
          <Route path="locations/:location_id/edit" component={OrganizationLocationEdit} title="Edit Location" />
          <Route path="programs/new" component={OrganizationProgramNew} title="Add Program" />
          <Route path="programs/:program_id/edit" component={OrganizationProgramEdit} title="Edit Program" />
          <Route path="users" component={OrganizationUsers} title="Organization Users" />
          <Route path="users/new" component={OrganizationUserNew} title="Add User" />
          <Route path="users/:user_id" component={OrganizationUserDetail} title="User Detail" />
          <Route path="users/:user_id/edit" component={OrganizationUserEdit} title="Edit User" />
        </Route>

        <Redirect from="*" to={catchAllLoggedInRedirectPath} />
      </Route>
    </Route>
  );
}
